import React from "react";
import clsx from "clsx";

import * as citationStyles from "../../../styles/widgets/citation.module.scss";

const Citation = ({text, bottom, alt, url, new_window}) => {

    let content = (<>
        <div className={citationStyles.item}>
            <blockquote>
                <p
                    className={clsx(citationStyles.h3Text, citationStyles.nbLines, citationStyles.citation)}
                >
                    {text}
                </p>
            </blockquote>
        </div>
        <div className={citationStyles.item}>
            <p
                style={{fontSize: 18, fontWeight: 500}}
                className={citationStyles.bottomLines}
            >
                {bottom}
            </p>
        </div>
    </>);

    return (<div className={citationStyles.bloc}>
        <div
            className={citationStyles.blocChild}
        >
            <div
                className={citationStyles.mainBloc}
            >
                {url ? (<a
                    href={url}
                    aria-label={alt}
                    className={citationStyles.link}
                    target={new_window ? "_blank" : "_self"}
                    rel="noreferrer"
                >
                    {content}
                </a>) : (content)}
            </div>
        </div>
    </div>);
};

export default Citation;
